export interface City {
    id: string
    name: string
    countryCode: string
    latitude: number
    longitude: number
}

export const CITIES: City[] = [
    {
        id: '1',
        name: 'carpay.notFound.search.cities.berlin',
        countryCode: 'DE',
        latitude: 52.520008,
        longitude: 13.404954
    },
    {
        id: '2',
        name: 'carpay.notFound.search.cities.munich',
        countryCode: 'DE',
        latitude: 48.137154,
        longitude: 11.576124
    },
    {
        id: '3',
        name: 'carpay.notFound.search.cities.hamburg',
        countryCode: 'DE',
        latitude: 53.551086,
        longitude: 9.993682
    },
    {
        id: '4',
        name: 'carpay.notFound.search.cities.zurich',
        countryCode: 'CH',
        latitude: 47.376887,
        longitude: 8.541694
    },
    {
        id: '5',
        name: 'carpay.notFound.search.cities.innsbruck',
        countryCode: 'AT',
        latitude: 47.269212,
        longitude: 11.404102
    },
    {
        id: '6',
        name: 'carpay.notFound.search.cities.cologne',
        countryCode: 'DE',
        latitude: 50.937531,
        longitude: 6.960279
    },
    {
        id: '7',
        name: 'carpay.notFound.search.cities.frankfurt',
        countryCode: 'DE',
        latitude: 50.110924,
        longitude: 8.682127
    },
    {
        id: '8',
        name: 'carpay.notFound.search.cities.vienna',
        countryCode: 'AT',
        latitude: 48.208176,
        longitude: 16.373819
    },
    {
        id: '9',
        name: 'carpay.notFound.search.cities.salzburg',
        countryCode: 'AT',
        latitude: 47.80949,
        longitude: 13.05501
    },
    {
        id: '10',
        name: 'carpay.notFound.search.cities.dusseldorf',
        countryCode: 'DE',
        latitude: 51.2277411,
        longitude: 6.7734556
    },
    {
        id: '11',
        name: 'carpay.notFound.search.cities.stuttgart',
        countryCode: 'DE',
        latitude: 48.7758459,
        longitude: 9.1829321
    },
    {
        id: '12',
        name: 'carpay.notFound.search.cities.hannover',
        countryCode: 'DE',
        latitude: 52.3758916,
        longitude: 9.7320104
    },
    {
        id: '13',
        name: 'carpay.notFound.search.cities.dresden',
        countryCode: 'DE',
        latitude: 51.0504088,
        longitude: 13.7372621
    },
    {
        id: '14',
        name: 'carpay.notFound.search.cities.leipzig',
        countryCode: 'DE',
        latitude: 51.3406321,
        longitude: 12.374
    }
]
